export const reviews = [
  {
    id: 'review-1',
    name: '吃瓜少女小丸子',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20casual%20style%20warm%20smile%20natural%20lighting%20simple%20clean%20background%20editorial%20portrait%20photography%20soft%20tones&width=80&height=80&seq=avatar-review-1&orientation=squarish',
    rating: 5,
    content: '911爆料网真的是我每天的快乐源泉！更新的速度太快了，每次有大瓜都能第一时间在这看到。已经推荐给身边所有闺蜜了，一起吃瓜太快乐了！',
    role: '忠实读者 · 关注2年',
  },
  {
    id: 'review-2',
    name: '娱乐圈观察家',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%20in%20his%2030s%20thoughtful%20expression%20clean%20modern%20look%20simple%20studio%20background%20editorial%20portrait%20photography%20warm%20natural%20lighting&width=80&height=80&seq=avatar-review-2&orientation=squarish',
    rating: 5,
    content: '作为在娱乐圈工作的人，我可以负责任地说，911爆料网的信息准确率在同类平台中是最高的。不是那种为了流量随便瞎编的自媒体，很多料都是有据可查的。',
    role: '圈内人士 · 关注1年',
  },
  {
    id: 'review-3',
    name: '熬夜冠军小明',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20student%20portrait%20casual%20hoodie%20friendly%20smile%20glasses%20simple%20indoor%20background%20editorial%20portrait%20photography%20soft%20natural%20lighting&width=80&height=80&seq=avatar-review-3&orientation=squarish',
    rating: 5,
    content: '每晚睡前必刷911爆料网，已经成习惯了。内容质量真的高，不是那种标题党，点进去都是有实锤的料。希望平台越做越好！',
    role: '铁杆粉丝 · 关注3年',
  },
  {
    id: 'review-4',
    name: '职场摸鱼达人',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20office%20lady%20portrait%20professional%20yet%20casual%20look%20light%20makeup%20warm%20smile%20clean%20studio%20background%20editorial%20portrait%20photography%20soft%20lighting&width=80&height=80&seq=avatar-review-4&orientation=squarish',
    rating: 4,
    content: '上班摸鱼的时候最喜欢刷911，内容新鲜热乎，评论区也特别有意思，网友们的才华真的是无穷的。唯一的小建议是希望App版本能有夜间模式~',
    role: '活跃用户 · 关注1年',
  },
  {
    id: 'review-5',
    name: '八卦研究生',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20in%20her%20late%2020s%20portrait%20stylish%20look%20intellectual%20vibe%20glasses%20warm%20expression%20clean%20modern%20background%20editorial%20portrait%20photography%20natural%20lighting&width=80&height=80&seq=avatar-review-5&orientation=squarish',
    rating: 5,
    content: '做自媒体快5年了，911爆料网是我每天必看的信息源。很多热点事件的来龙去脉都梳理得很清楚，帮我省了大量找素材的时间。强烈推荐！',
    role: '自媒体人 · 关注2年',
  },
  {
    id: 'review-6',
    name: '吃瓜不嫌事大',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20trendy%20street%20style%20casual%20confident%20expression%20urban%20background%20editorial%20portrait%20photography%20warm%20natural%20lighting%20modern%20vibe&width=80&height=80&seq=avatar-review-6&orientation=squarish',
    rating: 5,
    content: '跟其他爆料平台比起来，911的内容更有深度，不是纯粹的八卦，很多文章都有分析和社会意义的探讨。这才是高质量的吃瓜！',
    role: '深度读者 · 关注2年',
  },
];